import {
  createBlog,
  deleteBlogService,
  generateBlog,
  getBlogService,
  getSingleBlogService,
  updateBlogService
} from '@app/services/blog-service';
import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import toast from 'react-hot-toast';

export const useCreateBlog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (doc) => createBlog(doc),
    mutationKey: ['create-blog'],
    onSuccess: (res) => {
      toast.success(res?.message);
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to create blog');
    }
  });
};

export const useUpdateBlog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, blog }) => updateBlogService(id, blog),
    mutationKey: ['update-blog'],
    onSuccess: (res) => {
      toast.success(res?.message);
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to update blog');
    }
  });
};

export const useDeleteBlog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteBlogService(id),
    mutationKey: ['delete-blog'],
    onSuccess: (res) => {
      toast.success(res?.message);
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
      window.location.href = '/blogs';
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to delete blog');
    }
  });
};

export const useGenerateBlog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => generateBlog(payload),
    mutationKey: ['generate-blog'],
    onSuccess: (res) => {
      toast.success(res?.message);
      queryClient.invalidateQueries({ queryKey: ['blogs'] });
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to generate blog');
    }
  });
};

export const useGetBlog = (payload) => {
  return useQuery({
    queryKey: ['blogs', payload.page, payload.limit, payload.search, payload.status],
    queryFn: () => getBlogService(payload),
    enabled: !!payload,
    placeholderData: keepPreviousData
  });
};

export const useGetSingleBlog = (payload) => {
  return useQuery({
    queryKey: ['single-blog', payload],
    queryFn: () => getSingleBlogService(payload),
    enabled: !!payload
  });
};
